<template>
    <div>
        <!-- 头图部分 -->
        <div class="banner">
            <div class="main">
                <div class="swiper-container banner-swiper">
                    <div class="swiper-wrapper" v-if="bannerList.length">
                        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
                            <img :src="item.coverPicture" />
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                    <!-- <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div> -->
                </div>
            </div>
        </div>
        <!-- 新闻部分 -->
        <div class="news">
            <div class="main">
                <div class="swiper-container news-swiper">
                    <div class="swiper-wrapper" v-if="newsListSwiper.length">
                        <div class="swiper-slide" v-for="(item, index) in newsListSwiper" :key="index">
                            <img :src="item.coverPicture" style="width: 100%;height: 348px;" />
                            <p class="swiper-title">
                                {{ item.topic }}
                            </p>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
                <div class="right">
                    <div class="block" style="margin: 0; background: url('../../static/img/image4.png') no-repeat;  background-color: #31689b;">
                        <h4 class="title">协会动态</h4>
                        <a class="more" @click="handleMore('25')">更多>></a>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in newsDynamicList" :key="index" class="item" @click="detailNews(item)">
                                <a class="title">{{ item.topic }}</a>
                                <span class="date" v-if="item.publishTime"> [{{ item.publishTime.substring(0,10) }}]</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 政策 & 动态 -->
        <div class="news">
            <div class="main">
                <div class="left">
                    <div class="block" style="margin: 0; background: url('../../static/img/zfxxgka.png') no-repeat;  background-color: #31689b;">
                        <h4 class="title">通知公告</h4>
                        <a class="more" @click="handleMore('23')">更多>></a>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in newsNoticeList" :key="index" class="item" @click="detailNews(item)">
                                <a class="title">{{ item.topic }}</a>
                                <span class="date" v-if="item.publishTime"> [{{ item.publishTime.substring(0,10) }}]</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="right">
                    <div class="block" style="margin: 0">
                        <!-- <i class="line"></i> -->
                        <h4 class="title">政策法规</h4>
                        <a class="more" @click="handleMore('24')">更多>></a>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in newsPolicyList" :key="index" class="item" @click="detailNews(item)">
                                <a class="title">{{ item.topic }}</a>
                                <span class="date" v-if="item.publishTime"> [{{ item.publishTime.substring(0,10) }}]</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 合作伙伴 -->
        <div class="partner">
            <div class="main">
                <div class="link-con" style="position: relative">
                    <div class="swiper-container swiper2">
                        <ul v-if="partnerList.length" class="clearfix swiper-wrapper">
                            <li class="swiper-slide fl" v-for="(item, index) in partnerList" :key="index">
                                <img :src="item.picture" alt="" class="partner-img" />
                            </li>
                        </ul>
                    </div>
                    <div class="swiper-button-prev swiper-button-mine"></div>
                    <div class="swiper-button-next swiper-button-mine"></div>
                </div>
            </div>
        </div>
        <!-- 友情链接 -->
        <div class="link">
            <div class="main">
                <div class="block" style=" border-bottom: 2px solid rgb(11, 82, 144);background: none;">
                    <i class="line"></i>
                    <h4 class="title" style="color: #31689b;padding-left: 15px;">友情链接</h4>
                </div>
                <ul>
                    <li class="item" v-for="(item, index) in linkList" :key="index">
                        <a @click="detailLink(item)">
                            <img :src="item.picture" alt="" />
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 广告飘窗 -->
        <!-- <Popup></Popup> -->

        <div v-for="(item,index) in popupList" :key="index" style="width: 280px;">
            <div v-if="index == 0 && item.show" style="position: fixed;left: '0';top: 50px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

            <div v-if="index == 1 && item.show" style="position: fixed;right: 0;top: 40px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

            <div v-if="index == 2 && item.show" style="position: fixed;left: '0';top: 370px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

            <div v-if="index == 3 && item.show" style="position: fixed;right: 0;top: 360px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

            <div v-if="index == 4 && item.show" style="position: fixed;left: '0';bottom: 10px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

            <div v-if="index == 5 && item.show" style="position: fixed;right: 0;bottom: 10px; width: 280px">
                <div style="
                cursor: pointer;
                text-align: right;
                font-size: 12px;
                color: #999999;
              " @click="handleClose(index)">
                    关闭
                </div>
                <div style="background: #fff;padding: 14px;border-radius: 3px;box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);" class="box">
                    <h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">{{item.title}}</h4>
                    <div v-html="item.content"></div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import { getPopupQuery } from "../api/popup.js"
    import Popup from "../components/Popup.vue"
    import { getBannerQuery } from "../api/banner";
    import { getNewsList } from "../api/news";
    import { getLinksList } from "../api/link";
    import { getPartnerQuery } from "../api/partner.js"
    import Swiper from "swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        components: {
            Popup
        },
        data() {
            return {
                // 头图
                bannerList: [],
                bannerEmpty: false,
                bannerLoading: true,
                // 新闻轮播
                newsListSwiper: [],
                //协会动态
                newsDynamicList: [],
                //通知公告
                newsNoticeList: [],
                //政策法规
                newsPolicyList: [],

                // 新闻查询参数
                newsSearchParams: {
                    dictId: "",
                    page: 1,
                    pageSize: 7,
                    topic: "",
                },

                //友情链接
                linkList: [],

                //合作伙伴
                partnerList: [],

                popupList: []
            };
        },
        created() {
            this.getBannerQuery();
            this.getNewsBannerList();
            this.getNewsDynamicList();
            this.getNewsNoticeList();
            this.getNewsPolicyList();
            this.getPartnerQuery();
            this.getLinksList();
            this.getPopupQuery();
        },
        methods: {
            handleClose(index) {
                this.popupList.forEach((ele, i) => {
                    if (i == index) {
                        this.$set(ele, 'show', false)
                    }
                });
            },

            //获取弹窗
            getPopupQuery() {
                getPopupQuery().then(res => {
                    let popupList = res.data;
                    let arr = []
                    popupList.forEach((ele,i) => {
                        this.$set(ele, 'show', true)
                        if(ele.isEnabled) {
                            arr.push(ele)    
                        }
                    });
                    this.popupList = arr;
                })
            },

            //协会动态
            getNewsDynamicList() {
                let newsSearchParams = {
                    dictId: '25',
                    page: 1,
                    pageSize: 7,
                    topic: "",
                }
                getNewsList(newsSearchParams).then((res) => {
                    if (res.code == 200) {
                        this.newsDynamicList = res.data.records;
                    }
                });
            },

            //通知公告
            getNewsNoticeList() {
                let newsSearchParams = {
                    dictId: '23',
                    page: 1,
                    pageSize: 7,
                    topic: "",
                }
                getNewsList(newsSearchParams).then((res) => {
                    if (res.code == 200) {
                        this.newsNoticeList = res.data.records;
                    }
                });
            },

            //政策法规
            getNewsPolicyList() {
                let newsSearchParams = {
                    dictId: '24',
                    page: 1,
                    pageSize: 7,
                    topic: "",
                }
                getNewsList(newsSearchParams).then((res) => {
                    if (res.code == 200) {
                        this.newsPolicyList = res.data.records;
                    }
                });
            },

            //合作伙伴
            getPartnerQuery() {
                getPartnerQuery().then((res) => {
                    if (res.code == 200) {
                        this.partnerList = res.data;
                        this.initSwiperTrain();
                    }
                });
            },

            initSwiperTrain() {
                let that = this;
                setTimeout(() => {
                    let mySwiper = new Swiper(".swiper2", {
                        slidesPerGroup: 1,
                        slidesPerView: 3,
                        spaceBetween: 10,
                        autoplay: 3000,
                        speed: 300,
                        loop: true,
                        autoplayDisableOnInteraction: false,
                        effect: "slide",
                        observer: true,
                        observerParents: true,
                        observeSlideChildren: true,
                        prevButton: ".swiper-button-prev",
                        nextButton: ".swiper-button-next",
                        centeredSlides: true,
                        hideOnClick: true,
                        loopAdditionalSlides: 2,
                        onTap: function(mySwiper, event) {
                            const clickedRealIndex = parseInt(
                                mySwiper.clickedSlide.dataset.swiperSlideIndex ||
                                mySwiper.clickedIndex
                            );
                            const Index = clickedRealIndex;
                            let item = that.partnerList[Index];
                            if (item.jumpUrl) {
                                window.open(item.jumpUrl)
                                // let routeUrl = that.$router.resolve({
                                //     name: "AssociationDetail",
                                //     query: {
                                //         id: item.id,
                                //     },
                                // });
                                // window.open(routeUrl.href, "_blank");
                            }
                        },
                    });
                }, 500);
            },

            // 头图
            getBannerQuery() {
                getBannerQuery("1").then((res) => {
                    if (res.code == 200) {
                        this.bannerList = res.data;
                        this.initSwiperBanner();
                    }
                });
            },

            initSwiperBanner() {
                let that = this;
                setTimeout(() => {
                    let mySwiper = new Swiper(".banner-swiper", {
                        autoplay: 3000,
                        speed: 1000,
                        loop: true,
                        paginationClickable: true,
                        autoplayDisableOnInteraction: false,
                        effect: "slide",
                        observer: true,
                        observerParents: true,
                        observeSlideChildren: true,
                        preventClicks: false,
                        pagination: ".banner-swiper>.swiper-pagination",
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        hideOnClick: true,
                        onTap: function(mySwiper, event) {
                            let i = mySwiper.activeIndex;
                            if (i > that.bannerList.length) {
                                i = 1;
                            }
                            let item = that.bannerList[i - 1];
                            if (item.jumpUrl) {
                                window.open(item.jumpUrl);
                            }
                            // if (!item.jumpUrl && item.content) {
                            //     let routeUrl = that.$router.resolve({
                            //         name: "BannerDetail",
                            //         query: {
                            //             id: item.id,
                            //         },
                            //     });
                            //     window.open(routeUrl.href, "_blank");
                            // }
                        },
                    });
                }, 500);
            },

            // 新闻
            handleMore(dictId) {
                this.$router.push({
                    path: "/index/Infolist",
                    query: {
                        dictId
                    }
                });
            },

            detailNews(item) {
                let routeUrl = this.$router.resolve({
                    path: "/index/InfoDetail",
                    query: {
                        typeId: item.dictId,
                        id: item.id,
                    },
                });
                window.open(routeUrl.href, "_blank");
            },

            // 新闻轮播
            getNewsBannerList() {
                getBannerQuery("2").then((res) => {
                    if (res.code == 200) {
                        this.newsListSwiper = res.data;
                        this.initSwiperNews();
                    }
                });
            },

            initSwiperNews() {
                let that = this;
                setTimeout(() => {
                    let mySwiper = new Swiper(".news-swiper", {
                        autoplay: 3000,
                        speed: 1000,
                        loop: true,
                        paginationClickable: true,
                        autoplayDisableOnInteraction: false,
                        effect: "slide",
                        observer: true,
                        observerParents: true,
                        observeSlideChildren: true,
                        preventClicks: false,
                        pagination: ".news-swiper>.swiper-pagination",
                        navigation: {
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                        },
                        hideOnClick: true,
                        onTap: function(mySwiper, event) {
                            let i = mySwiper.activeIndex;
                            if (i > that.newsListSwiper.length) {
                                i = 1;
                            }
                            let item = that.newsListSwiper[i - 1];
                            if (item.jumpUrl) {
                                window.open(item.jumpUrl)
                            }
                            // let routeUrl = that.$router.resolve({
                            //     name: "NewsDetail",
                            //     query: {
                            //         typeId: item.dictId,
                            //         id: item.id,
                            //     },
                            // });
                            // window.open(routeUrl.href, "_blank");
                        },
                    });
                }, 1000);
            },


            //友情链接
            getLinksList() {
                let params = {
                    title: "",
                };
                getLinksList(params).then((res) => {
                    if (res.code == 200) {
                        this.linkList = res.data;
                    }
                });
            },

            detailLink(item) {
                window.open(item.jumpUrl);
            },
        },
    };
</script>

<style>
    @import "../assets/style.css";
    @import "../assets/style-mob.css";
</style>

<style scoped>
    .swiper2 {
        width: 1200px;
        padding-top: 40px;
        padding-bottom: 20px;
        overflow: hidden;
        margin: 0 auto;
    }

    .partner-img {
        width: 310px;
        height: 58px;
        display: block;
        margin: 0 auto;
    }
</style>

<style>
    .swiper-slide {
        cursor: pointer;
    }

    .swiper-pagination-bullet-active {
        background: #306baf !important;
        opacity: 1 !important;
    }

    .swiper-button-prev {
        width: 19px !important;
        height: 19px !important;
        top: 82px;
        background: url(../../static/img/imgbtnl.png) !important;
    }

    .swiper-button-next {
        width: 19px !important;
        height: 19px !important;
        top: 82px;
        background: url(../../static/img/imgbtnr.png) !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/HomePage.vue